import { render, staticRenderFns } from "./TotalRegisters.vue?vue&type=template&id=7b408fe6&"
import script from "./TotalRegisters.vue?vue&type=script&lang=js&"
export * from "./TotalRegisters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports